import { useEffect } from 'react';

type Props = {
  title: string;
};

const useSetPageTitle = ({ title }: Props) => {
  useEffect(() => {
    document.title = (title ? `${title} – ` : '') + 'Trackman University';
    return () => {
      document.title = 'Trackman University';
    };
  }, [title]);

};

export default useSetPageTitle;
